import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Política de Privacidad

Última actualización: marzo 2026

Tu privacidad es importante para nosotros. Esta política describe cómo recopilamos, usamos y protegemos tu información personal.

1. Información que recopilamos
Recopilamos únicamente la información necesaria para procesar tu compra: nombre, dirección de correo electrónico y datos de pago. Los datos de pago son procesados de forma segura por Hotmart y no almacenamos información de tarjetas de crédito.

2. Uso de la información
Utilizamos tu información para:
• Procesar y entregar tu compra.
• Enviarte el producto digital adquirido.
• Comunicarnos contigo respecto a tu pedido.

3. Protección de datos
Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, alteración o destrucción.

4. Compartir información
No vendemos, intercambiamos ni transferimos tu información personal a terceros, excepto a los proveedores de servicios necesarios para completar tu transacción (como la plataforma de pago Hotmart).

5. Cookies
Nuestro sitio puede utilizar cookies para mejorar tu experiencia de navegación y con fines analíticos.

6. Tus derechos
Tienes derecho a acceder, rectificar o eliminar tu información personal en cualquier momento.
`.trim();
const termsContent = `
Términos y Condiciones

Última actualización: marzo 2026

Al realizar una compra en este sitio, aceptas los siguientes términos y condiciones.

1. Producto digital
"Ya No me Habla" es un producto digital en formato PDF. Una vez completada la compra, recibirás acceso inmediato al material.

2. Uso personal
El contenido adquirido es para uso personal y no puede ser reproducido, distribuido o compartido sin autorización previa.

3. Política de reembolso
Ofrecemos una garantía de satisfacción. Si no estás conforme con el producto, puedes solicitar un reembolso dentro de los 7 días posteriores a la compra, conforme a las políticas de la plataforma Hotmart.

4. Propiedad intelectual
Todo el contenido del producto, incluyendo textos, gráficos y metodologías, está protegido por derechos de autor. Queda prohibida su reproducción total o parcial sin consentimiento.

5. Limitación de responsabilidad
El contenido de esta guía es de carácter informativo y educativo. No sustituye el consejo profesional de un psicólogo o terapeuta familiar. Los resultados pueden variar según cada situación familiar.

6. Modificaciones
Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán efectivas desde su publicación en este sitio.

7. Plataforma de pago
Las transacciones son procesadas a través de Hotmart, una plataforma segura de pagos digitales. Al realizar tu compra, también aceptas los términos de servicio de Hotmart.
`.trim();
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-cream-alt border-t border-subtle py-8 px-4" data-id="element-39">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-secondary font-body" data-id="element-40">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-primary transition-colors underline underline-offset-2" data-id="element-41">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline text-subtle" data-id="element-42">|</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-primary transition-colors underline underline-offset-2" data-id="element-43">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-44">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setActiveModal(null)} data-id="element-45">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-card rounded-sm shadow-warm-lg border border-subtle w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-46">
              <div className="flex items-center justify-between p-6 border-b border-subtle" data-id="element-47">
                <h3 className="text-xl font-heading font-bold text-primary" data-id="element-48">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-secondary hover:text-primary transition-colors p-1" aria-label="Cerrar" data-id="element-49">
                  <XIcon className="w-5 h-5" data-id="element-50" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto" data-id="element-51">
                <div className="text-secondary font-body leading-relaxed whitespace-pre-line text-sm" data-id="element-52">
                  {activeModal === 'privacy' ? privacyContent : termsContent}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}